
(function(template){
define('vue!optionalClassProgram/components/container',['Vue','vuex','vue!./userComponents/tempUserComponent','vue!./userComponents/loggedInUserComponents/loggedInUserComponent','vue!./helperComponents/loaderComponent'],function(Vue,vuex,tempUserComponent,loggedInUserComponent,loadingIndicator){
    return {
        name: 'optionalClassProgram',
        template: template,
        components: {
            'tempUserComponent' : tempUserComponent,
            'loggedInUserComponent':loggedInUserComponent,
            'loadingIndicator':loadingIndicator

        },
           computed: _.extend( vuex.mapState(['loggedInUser','users','currentlyBookingClassProgram','usersWithIds']),{
           }),
        props:['program'],
        data: function(){
            return{
                error: '',
                isBooking:false
            }
        },
        methods: {
             bookClass: function(){
                var self = this;
                if(app.data.userLoggedIn){
                    var members = app.data.spaClassQueue[self.program.StartTime+'-'+self.program.SpaClassId]
                    _.each(members, function (member,i) {
                        var userId =  member.CustomerId;
                        app.customization.spaBooking.spaClassQtyBookMode && app.data.userLoggedIn? userId = userId + '-' + i: ''
                        var optionalClassList = self.users[userId].optionalClassListIds
                        if(optionalClassList){
                         member.optionalClassList = optionalClassList
                        }
                    })
                }else{
                    var optionalClassList = self.users[self.tempCustomerId].optionalClassListIds
                    app.data.user_equipment_not_loggedin.optionalClassList = optionalClassList
                }
                var hasGrouping = !!(self.program.IsProgramHeader == "Y" && !_.isEmpty(self.program.Groups))
                   this.isBooking = true
                  app.dispatcher.dispatch('spaBooking', 'bookClass', [app.data['selected/spa/spaLocations/SpaLocation/'], self.currentlyBookingClassProgram.SpaClassId,'',self.currentlyBookingClassProgram.StartTime,'',1,1,hasGrouping ? 1: 0]);
            }
        },
        beforeMount: function () {
            var self = this
            if (app.data.userLoggedIn) {
                self.$store.commit('setLoggedInUser', {userId: app.data.CustomerId});
            }
    console.log("program",self.program)
            InitializeMembersAndDetails()
            var components = app.data.eventPrograms[this.program.SpaClassId]
            components = _.sortBy(components,function(x){return x.SortOrder})
            self.$store.commit('intializeClassComponentPerUser', { classComponents:components })
            self.$store.commit('addCurrentlyBookingClassProgram', self.program)


            function InitializeMembersAndDetails() {
                var members = app.data.spaClassQueue[self.program.StartTime+'-'+self.program.SpaClassId] || [].concat(app.data.user_equipment_not_loggedin)
                _.each(members, function (member,i) {

                   var userId =  member.CustomerId
                   app.customization.spaBooking.spaClassQtyBookMode && app.data.userLoggedIn? userId = userId + '-' + i: ''
                    if (!self.users[userId]) {
                        self.$store.commit('addUser', {
                            userId: userId
                        });
                    } //by default logged in or not logged in user customer id exists
                    self.$store.commit('addAgeForUser', {
                            userId: userId,
                            birthdate: member.birthdate
                    });
                    self.$store.commit('addEventPerUserDetails', { //group item user chose under same program could be different; thus, has different price and name
                            userId: userId,
                            eventName: member.ProgramName,
                            eventPrice: member.Price,
                            isBookingClass: true
                    });
                    self.$store.commit('addUserWithId', {
                        name: member.CustomerName,
                        id: userId
                    })
                })
            if (app.data.userLoggedIn) {
                    //when app initializes, logged  customer is already added to store.users. So if logged customer is not the one who is going to book a program, it will show extra user entry in program confirmation screen. To avoid that, will check if logged in user is not there  in the list of those who are going to take this program, then remove it from store.users
                var isLoggedInUserBookingProgram =  _.find(members,function(member){
                    return member.CustomerId == app.data.CustomerId
                })
                !isLoggedInUserBookingProgram ? self.$store.commit('removeUser', {userId: app.data.CustomerId }): ''

            }

            }

        }
    }
})
})('<div class="optionalClassProgram" > <loading-indicator :showLoader="isBooking"></loading-indicator> <div class="segment"> <div class="segment-header yellowHeader">{{localization.spaBooking.packageBooking.optionalClass.locationSelectHeader}}</div> <div class="segment-body"> <div class="segment bookingModeHeaders"> <div class="segment-header greyHeader">{{localization.spaBooking.confirmation.title}}</div> </div> <loggedInUserComponent v-if="loggedInUser"></loggedInUserComponent> <tempUserComponent v-else></tempUserComponent> </div> </div> <div class="register-button-div"> <button v-on:click="bookClass" class="btn service-for-button btn-warning" >{{localization.spaBooking.confirmation.makeEventBookingButtonLabel}}</button> </div> </div>');
